import { downloadData, getUrl, list } from 'aws-amplify/storage'
import {
  S3_STORAGE_SCOPE,
  resolveS3StorageTarget,
} from '@/config/portalEnvironment'

const STORAGE_READ_OPTIONS = {
  expiresIn: 3600,
  validateObjectExistence: false,
  useAccelerateEndpoint: false,
}

export function buildAmplifyBucketOptions(scope = S3_STORAGE_SCOPE.GENERAL, hostname) {
  const { bucket, region } = resolveS3StorageTarget(scope, hostname)
  return {
    bucket: {
      bucketName: bucket,
      region,
    },
  }
}

export function buildPublicS3Url(s3Key, scope = S3_STORAGE_SCOPE.GENERAL, hostname) {
  const { bucket, region } = resolveS3StorageTarget(scope, hostname)
  const path = String(s3Key || '')
    .trim()
    .split('/')
    .map(encodeURIComponent)
    .join('/')
  return `https://${bucket}.s3.${region}.amazonaws.com/${path}`
}

export async function downloadS3ObjectBlob(
  s3Key,
  scope = S3_STORAGE_SCOPE.GENERAL,
  hostname,
) {
  const path = String(s3Key || '').trim()
  if (!path) return null

  const { body } = await downloadData({
    path,
    options: {
      ...STORAGE_READ_OPTIONS,
      ...buildAmplifyBucketOptions(scope, hostname),
    },
  }).result

  const blob = await body.blob()
  return blob?.size > 0 ? blob : null
}

export async function getS3ObjectSignedUrl(
  s3Key,
  scope = S3_STORAGE_SCOPE.GENERAL,
  hostname,
) {
  const path = String(s3Key || '').trim()
  if (!path) return null

  const { url } = await getUrl({
    path,
    options: {
      ...STORAGE_READ_OPTIONS,
      ...buildAmplifyBucketOptions(scope, hostname),
    },
  })

  const href = url?.toString?.() ?? (url != null ? String(url) : '')
  return href || null
}

export async function listS3ObjectKeys(
  prefix,
  scope = S3_STORAGE_SCOPE.GENERAL,
  hostname,
) {
  const path = normalizeS3Prefix(prefix)
  if (!path) return []

  const response = await list({
    path,
    options: {
      listAll: true,
      ...buildAmplifyBucketOptions(scope, hostname),
    },
  })

  const items = Array.isArray(response?.items) ? response.items : []
  return items
    .map((item) => String(item?.path || item?.key || '').trim())
    .filter(Boolean)
}

export function normalizeS3Prefix(prefix) {
  let value = String(prefix ?? '').trim()
  if (!value) return ''
  if (!value.endsWith('/')) value += '/'
  return value
}

export { S3_STORAGE_SCOPE }
